import { usePostLogin } from "../provider/Context";
import useAzureAuthenticate from "./useAzureAuthenticate";
import useHandleAzureSignupHint from "./useHandleAzureSignupHint";

/***
 * Provides a handler for azure login result that validates it with the api and logs in or -
 * redirect to signup if the user doesn't exits
 * @returns {(authenticationResult: AuthenticationResult) => Promise<void>}
 */
function useLoginWithAzure() {
  const { onLoginSuccess } = usePostLogin();
  const handleHint = useHandleAzureSignupHint();

  return useAzureAuthenticate(onLoginSuccess, (authPayload, err) => handleHint(authPayload, err.response.body));
}

export default useLoginWithAzure;
